var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"pt-10 mt-10"},[_c('v-col',{attrs:{"cols":"12","align":"center"}},[_c('v-progress-circular',{attrs:{"size":70,"width":5,"color":"primary","indeterminate":""}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }